import { Action } from 'vuex';
import { ConversationalAiState, RootState } from '../types';
import { getTracker } from '@/tracking/trackingPlugin';
import { ConversationalAiEvent } from '@/tracking/trackingTypes';
import { Project } from '@/types';

const actions: { [key: string]: Action<ConversationalAiState, RootState> } = {
  setIsOpen({ dispatch }, { project, open }: { project: Project; open: boolean }) {
    dispatch(
      'user/setLocalConfig',
      {
        [`projects.${project.id}.isConversationalAiOpen`]: open,
      },
      { root: true }
    );
  },

  async show({ dispatch, rootState }, data: { project: Project; batchSelectedSourceIds?: Array<string> }) {
    getTracker().track(ConversationalAiEvent.ConversationalAiOpened);

    const modal = {
      type: 'ConversationalAi',
      payload: {
        user: rootState.user.user,
        ...data,
      },
    };

    const shown = await dispatch('modal/show', modal, { root: true });

    if (!shown && data.batchSelectedSourceIds) {
      // The panel is already visible — asking for it again from the source manager (batch action or a
      // row's overflow menu) must still hand it the current selection, but `modal/show` is a no-op for
      // an open modal, so its payload would keep the selection from the first open (ATIW-412).
      // Only callers that carry a selection refresh it: reopening the panel as a side effect of
      // navigation passes none, and must leave the selection on screen untouched.
      await dispatch('modal/updatePayload', modal, { root: true });
    }

    dispatch('setIsOpen', { project: data.project, open: true });
  },

  hide({ dispatch }, data: { project: Project }) {
    dispatch(
      'modal/hide',
      {
        type: 'ConversationalAi',
      },
      { root: true }
    );

    dispatch('setIsOpen', { project: data.project, open: false });
  },
};

export default {
  namespaced: true,
  actions,
};
